
export function GetNormalizationDataH3(zoom, height) {
    switch (zoom) {
        case 'z4':
            return z4NormalizeH3(height)
        case 'z5':
            return z5NormalizeH3(height)
        case 'z6':
            return z6NormalizeH3(height)
        case 'z7':
            return z7NormalizeH3(height)
    }
}

function z4NormalizeH3(height) {
    let minmax = { min: 0, max: 1 }
    switch (height) {
        case 'population':
            minmax = { min: 16.17973208, max: 23191619.52 }
            break;
        case 'avg_building_height':
            minmax = { min: 3, max: 3.751193154 }
            break;
        case 'building_area':
            minmax = { min: 103.0309029, max: 559567509.3 }
            break;
        case 'num_res_buildings':
            minmax = { min: 2, max: 3768474 }
            break;
        case 'num_buildings':
            minmax = { min: 2, max: 4010206 }
            break;
    }
    return minmax
}

function z5NormalizeH3(height) {
    let minmax = { min: 0, max: 1 }
    switch (height) {
        case 'population':
            minmax = { min: 0.3749091724, max: 6260858.327 }
            break;
        case 'avg_building_height':
            minmax = { min: 3, max: 4.843108781 }
            break;
        case 'building_area':
            minmax = { min: 20.36515487, max: 115527398.1 }
            break;
        case 'num_res_buildings':
            minmax = { min: 1, max: 813516 }
            break;
        case 'num_buildings':
            minmax = { min: 1, max: 833791 }
            break;
    }
    return minmax
}

function z6NormalizeH3(height) {
    let minmax = { min: 0, max: 1 }
    switch (height) {
        case 'population':
            minmax = { min: 0.169256214, max: 1108300.827}
            break;
        case 'avg_building_height':
            minmax = { min: 3, max: 6.087446293 }
            break;
        case 'building_area':
            minmax = { min: 8.8830153, max: 25535647.36 }
            break;
        case 'num_res_buildings':
            minmax = { min: 1, max: 156385 }
            break;
        case 'num_buildings':
            minmax = { min: 1, max: 160003 }
            break;
    }
    return minmax
}

function z7NormalizeH3(height) {
    let minmax = { min: 0, max: 1 }
    switch (height) {
        case 'population':
            minmax = { min: 0.1357684604, max: 1135440.652 }
            break;
        case 'avg_building_height':
            minmax = { min: 3, max: 11.45588003 }
            break;
        case 'building_area':
            minmax = { min: 7.125489121, max: 4701776.449 }
            break;
        case 'num_res_buildings':
            minmax = { min: 0, max: 30065 }
            break;
        case 'num_buildings':
            minmax = { min: 1, max: 30667 }
            break;
    }
    return minmax
}